module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.4fcb4d5b.webp";